<template>
  <div>
    <!-- 标题栏 -->
    <div class="searchBox">
      <div>
        <!-- <el-input v-model="keyword" placeholder="订单号" style="width: 250px" size="small" clearable></el-input>
        <el-input v-model="keyword2" placeholder="货号" style="width: 250px;margin-left: 5px;" size="small" clearable></el-input>
        <el-button type="primary" size="small" style="margin-left: 10px" @click="search"><i class="el-icon-search" style="margin-right: 5px"></i>搜索</el-button>
        <el-button size="small" @click="reset"><i class="el-icon-refresh-left" style="margin-right: 5px"></i>重置</el-button> -->
        <el-date-picker v-model="today" type="date" placeholder="选择日期" @change="search"
          :clearable="true" :editable="false" style="margin-left: 10px"></el-date-picker>
      </div>
      <div>
        <el-button type="success" size="small" style="margin-left: 10px" @click="add"><i class="el-icon-plus" style="margin-right: 5px"></i>新增</el-button>
      </div>
    </div>

    <div class="mainBox" style="display: flex; padding: 0; height: 100%">
      <div style="width: calc(100%); padding: 20px; height: calc(100vh - 50px - 113px)" v-loading="listLoading">
        <el-table :data="list" element-loading-text="Loading" fit highlight-current-row border height="calc(100% - 72px)" style="width: 100%">
          <el-table-column align="center" label="日期" min-width="100" prop="riqi"></el-table-column>
          <el-table-column align="center" label="前处理装框当日工资" min-width="100" prop="zhuangkuang"></el-table-column>
          <el-table-column align="center" label="前处理淋洗当日工资" min-width="100" prop="linxi"></el-table-column>
          <el-table-column align="center" label="枪手一线白班当日工资" min-width="100" prop="qsbaiban1"></el-table-column>
          <el-table-column align="center" label="枪手一线1白班当日工资" min-width="100" prop="qsbaiban11"></el-table-column>
          <el-table-column align="center" label="枪手二线白班当日工资" min-width="100" prop="qsbaiban2"></el-table-column>
          <el-table-column align="center" label="枪手二线1白班当日工资" min-width="100" prop="qsbaiban21"></el-table-column>
          <el-table-column align="center" label="枪手三线白班当日工资" min-width="100" prop="qsbaiban3"></el-table-column>
          <el-table-column align="center" label="枪手三线1白班当日工资" min-width="100" prop="qsbaiban31"></el-table-column>
          <el-table-column align="center" label="枪手四线白班当日工资" min-width="100" prop="qsbaiban4"></el-table-column>
          <el-table-column align="center" label="枪手四线1白班当日工资" min-width="100" prop="qsbaiban41"></el-table-column>
          <el-table-column align="center" label="枪手其他当日工资" min-width="100" prop="qsbaiban5"></el-table-column>
          <el-table-column align="center" label="普工一线白班当日工资" min-width="100" prop="pgbaiban1"></el-table-column>
          <el-table-column align="center" label="普工一线1白班当日工资" min-width="100" prop="pgbaiban11"></el-table-column>
          <el-table-column align="center" label="普工二线白班当日工资" min-width="100" prop="pgbaiban2"></el-table-column>
          <el-table-column align="center" label="普工二线1白班当日工资" min-width="100" prop="pgbaiban21"></el-table-column>
          <el-table-column align="center" label="普工三线白班当日工资" min-width="100" prop="pgbaiban3"></el-table-column>
          <el-table-column align="center" label="普工三线1白班当日工资" min-width="100" prop="pgbaiban31"></el-table-column>
          <el-table-column align="center" label="普工四线白班当日工资" min-width="100" prop="pgbaiban4"></el-table-column>
          <el-table-column align="center" label="普工四线1白班当日工资" min-width="100" prop="pgbaiban41"></el-table-column>
          <el-table-column align="center" label="普工其他当日工资" min-width="100" prop="pgbaiban5"></el-table-column>
          <el-table-column align="center" label="操作" width="120" fixed="right">
            <template slot-scope="scope">
              <el-button type="text" @click="edit(scope.row.id)">编辑</el-button>
              <el-button type="text" @click="del(scope.row.id)" style="color: #f56c6c">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div style="padding: 20px; text-align: center">
          <el-pagination
            background
            layout="total, sizes,prev, pager, next, jumper"
            @size-change="pageSizeChange"
            :total="total"
            @current-change="pageChange"
            :current-page="pageNum"
            :page-size="pageSize"
          >
          </el-pagination>
        </div>
      </div>
    </div>

    <!-- 添加修改弹窗 -->
    <el-dialog title="编辑" :visible.sync="editModal">
      <el-form :model="editForm" ref="EditForm" label-width="200px" :rules="rules">
        <el-form-item label="日期" prop="riqi">
          <el-date-picker v-model="editForm.riqi" value-format="timestamp"
            type="date" placeholder="选择日期"></el-date-picker>
        </el-form-item>
        <el-form-item label="前处理装框当日工资" prop="zhuangkuang">
          <el-input-number v-model="editForm.zhuangkuang" :precision="5" :step="1" :max="100000000"></el-input-number>
        </el-form-item>
        <el-form-item label="前处理淋洗当日工资" prop="linxi">
          <el-input-number v-model="editForm.linxi" :precision="5" :step="1" :max="100000000"></el-input-number>
        </el-form-item>
        <el-form-item label="枪手一线白班当日工资" prop="qsbaiban1">
          <el-input-number v-model="editForm.qsbaiban1" :precision="5" :step="1" :max="100000000"></el-input-number>
        </el-form-item>
        <el-form-item label="枪手一线1白班当日工资" prop="qsbaiban11">
          <el-input-number v-model="editForm.qsbaiban11" :precision="5" :step="1" :max="100000000"></el-input-number>
        </el-form-item>
        <el-form-item label="枪手二线白班当日工资" prop="qsbaiban2">
          <el-input-number v-model="editForm.qsbaiban2" :precision="5" :step="1" :max="100000000"></el-input-number>
        </el-form-item>
        <el-form-item label="枪手二线1白班当日工资" prop="qsbaiban21">
          <el-input-number v-model="editForm.qsbaiban21" :precision="5" :step="1" :max="100000000"></el-input-number>
        </el-form-item>
        <el-form-item label="枪手三线白班当日工资" prop="qsbaiban3">
          <el-input-number v-model="editForm.qsbaiban3" :precision="5" :step="1" :max="100000000"></el-input-number>
        </el-form-item>
        <el-form-item label="枪手三线1白班当日工资" prop="qsbaiban31">
          <el-input-number v-model="editForm.qsbaiban31" :precision="5" :step="1" :max="100000000"></el-input-number>
        </el-form-item>
        <el-form-item label="枪手四线白班当日工资" prop="qsbaiban4">
          <el-input-number v-model="editForm.qsbaiban4" :precision="5" :step="1" :max="100000000"></el-input-number>
        </el-form-item>
        <el-form-item label="枪手四线1白班当日工资" prop="qsbaiban41">
          <el-input-number v-model="editForm.qsbaiban41" :precision="5" :step="1" :max="100000000"></el-input-number>
        </el-form-item>
        <el-form-item label="枪手其他当日工资" prop="qsbaiban5">
          <el-input-number v-model="editForm.qsbaiban5" :precision="5" :step="1" :max="100000000"></el-input-number>
        </el-form-item>
        <el-form-item label="普工一线白班当日工资" prop="pgbaiban1">
          <el-input-number v-model="editForm.pgbaiban1" :precision="5" :step="1" :max="100000000"></el-input-number>
        </el-form-item>
        <el-form-item label="普工一线1白班当日工资" prop="pgbaiban11">
          <el-input-number v-model="editForm.pgbaiban11" :precision="5" :step="1" :max="100000000"></el-input-number>
        </el-form-item>
        <el-form-item label="普工二线白班当日工资" prop="pgbaiban2">
          <el-input-number v-model="editForm.pgbaiban2" :precision="5" :step="1" :max="100000000"></el-input-number>
        </el-form-item>
        <el-form-item label="普工二线1白班当日工资" prop="pgbaiban21">
          <el-input-number v-model="editForm.pgbaiban21" :precision="5" :step="1" :max="100000000"></el-input-number>
        </el-form-item>
        <el-form-item label="普工三线白班当日工资" prop="pgbaiban3">
          <el-input-number v-model="editForm.pgbaiban3" :precision="5" :step="1" :max="100000000"></el-input-number>
        </el-form-item>
        <el-form-item label="普工三线1白班当日工资" prop="pgbaiban31">
          <el-input-number v-model="editForm.pgbaiban31" :precision="5" :step="1" :max="100000000"></el-input-number>
        </el-form-item>
        <el-form-item label="普工四线白班当日工资" prop="pgbaiban4">
          <el-input-number v-model="editForm.pgbaiban4" :precision="5" :step="1" :max="100000000"></el-input-number>
        </el-form-item>
        <el-form-item label="普工四线1白班当日工资" prop="pgbaiban41">
          <el-input-number v-model="editForm.pgbaiban41" :precision="5" :step="1" :max="100000000"></el-input-number>
        </el-form-item>
        <el-form-item label="普工其他当日工资" prop="pgbaiban5">
          <el-input-number v-model="editForm.pgbaiban5" :precision="5" :step="1" :max="100000000"></el-input-number>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="editModal = false">取 消</el-button>
        <el-button type="primary" @click="save">确 定</el-button>
      </div>
    </el-dialog>
    
  </div>
</template>

<script>
const editFormData = () => {
  return {
    riqi: '',
    zhuangkuang: 0,
    linxi: 0,
    qsbaiban1: 0,
    qsbaiban11: 0,
    qsbaiban2: 0,
    qsbaiban21: 0,
    qsbaiban3: 0,
    qsbaiban31: 0,
    qsbaiban4: 0,
    qsbaiban41: 0,
    qsbaiban5: 0,
    pgbaiban1: 0,
    pgbaiban11: 0,
    pgbaiban2: 0,
    pgbaiban21: 0,
    pgbaiban3: 0,
    pgbaiban31: 0,
    pgbaiban4: 0,
    pgbaiban41: 0,
    pgbaiban5: 0,
  }
}
export default {
  data() {
    return {
      url: this.$host,
      list: null,
      pageNum: 1,
      pageSize: 20,
      total: 0,
      listLoading: true,
      keyword: "",
      keyword2: "",
      keywordType: 1,
      editModal: false,
      editForm: editFormData(),
      rules: {
        
      },
      sf: '',
      today: '',
    }
  },

  created() {
    this.sf = localStorage.sf
    this.getList()
  },

  methods: {
    search() {
      this.pageNum = 1
      this.getList()
    },
    
    reset() {
      this.keyword = ""
      this.keyword2 = ""
      this.today = ''
      this.search()
    },
    
    add() {
      this.editForm = JSON.parse(JSON.stringify(editFormData()))
      this.editModal = true
    },

    edit(id) {
      this.$request.post('/index.php/admin/Ordermodel/tzgzMbInfo', {id: id}).then((res) => {
        this.editForm = res.data.data
        this.editForm.riqi = parseInt(this.editForm.riqi*1000)
        this.editModal = true
      }).catch(err => {
        console.log(err)
      })
    },

    del(id) {
      this.$confirm("请确认是否删除该条信息?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$request.post('/index.php/admin/Ordermodel/tzgzMbDel', {id: id}).then((res) => {
          this.$message.success(res.data.msg)
          this.getList()
        }).catch(err => {
          console.log(err)
        })
      })
    },

    save() {
      this.$refs["EditForm"].validate((valid) => {
        if (valid) {
          let data = JSON.parse(JSON.stringify(this.editForm))
          data.riqi = parseInt(data.riqi/1000)
          data.account = localStorage.account
          this.$request.post('/index.php/admin/Ordermodel/tzgzMbSave', data).then((res) => {
            this.$message.success(res.data.msg)
            this.editModal = false
            this.getList()
          }).catch(err => {
            console.log(err)
          })
        }
      })
    },


    pageChange(page) {
      this.pageNum = page
      this.getList()
    },

    pageSizeChange(size) {
      this.pageSize = size
      this.getList()
    },

    getList() {
      this.listLoading = true
      let data = {
        page: this.pageNum,
        num: this.pageSize,
      }
      if(this.keyword) {
        data.keyword = this.keyword
      }
      if(this.keyword2) {
        data.keyword2 = this.keyword2
      }
      if(this.today) {
        data.year = this.today.getFullYear()
        data.month = this.today.getMonth()+1
        data.day = this.today.getDate()
      }
      this.$request.post('/index.php/admin/Ordermodel/tzgzMbList', data).then((res) => {
        this.list = res.data.data
        this.total = res.data.count
        this.listLoading = false
      }).catch(err => {
        console.log(err)
      })
    },
  },
}
</script>
<style scoped="">

</style>
